var render = function render(){var _vm=this,_c=_vm._self._c;return _c('np-select',_vm._g({attrs:{"field":_vm.field,"records":_vm.records,"options":_vm.options}},_vm.listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }